import { render, staticRenderFns } from "./SaveAfterShow.vue?vue&type=template&id=781f80ba&scoped=true&"
import script from "./SaveAfterShow.vue?vue&type=script&lang=ts&"
export * from "./SaveAfterShow.vue?vue&type=script&lang=ts&"
import style0 from "./SaveAfterShow.vue?vue&type=style&index=0&id=781f80ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f80ba",
  null
  
)

export default component.exports